import React, { FC, Fragment, useState } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
// import { DEMO_STAY_LISTINGS } from "data/listings";
// import StartRating from "components/StartRating/StartRating";
// import { Link } from "react-router-dom";
import BtnLikeIcon from "components/BtnLikeIcon/BtnLikeIcon";
import SaleOffBadge from "components/SaleOffBadge/SaleOffBadge";
// import Badge from "shared/Badge/Badge";
import { ListingDataType } from "data/types";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Dialog, Transition } from "@headlessui/react";




export interface PropertyCardHProps {
  className?: string;
  data: ListingDataType;
  onButtonClick: (info: any) => void;
}


// const DEMO_DATA = DEMO_STAY_LISTINGS[0];

const PropertyCard: FC<PropertyCardHProps> = ({
  className = "",
  data ,
  onButtonClick
}) => {
  const {
    galleryImgs =[],
    title,
    author,
    address,
    saleOff,
    type,
    like,
    price,
    id,
  } = data;
  const location = useLocation();
  const {user, isAuthenticated} = useAuth0();
  let [isSaveModal, setIsSaveModal] = useState(false);
  let [isRemoveModal, setIsRemoveModal] = useState(false);

  // console.log(location.pathname);
  const handleClick = () => {
    // Call the callback function and pass the information
    onButtonClick(data);
  };

  function saveProperty(id: string | number){
    if(isAuthenticated){
      // console.log(`Saving item with id ${id}`);
      setIsSaveModal(true);
    }else{
      // console.log("please log in");
      setIsSaveModal(true);
    }
  };

  function removeProperty(id: string | number){
    //if(isAuthenticated){
      // console.log(`removing item with id ${id}`);
      setIsRemoveModal(true);
   
  };

  function closeModalSave() {
    setIsSaveModal(false);
  }
  function closeModalRemove() {
    setIsRemoveModal(false);
  }

  const renderModalSave = () => {
    return (
      <Transition appear show={isSaveModal} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalSave}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 " />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-8 h-[100px] w-[400px]">
              {isAuthenticated ? (
                  <div className="bg-white border-t-4 border-[#19CFD8] rounded-b text-teal-900 px-4 py-3 shadow-md" role="alert">
                  <div className="flex">
                    <div className="py-1"><svg className="fill-[#19CFD8] h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
                    <div>
                      <p className="font-bold text-left">Saved</p>
                      <p className="text-sm">The property is in your profile.</p>
                    </div>
                  </div>
                </div>
                ) : (
                  <div className="bg-white border-t-4 border-orange-500 rounded-b text-teal-900 px-4 py-3 shadow-md" role="alert">
                    <div className="flex">
                      <div className="py-1"><svg className="fill-orange-500 h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
                      <div>
                        <p className="font-bold text-left">Register / Login</p>
                        <p className="text-sm">Please Login to save properties</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  }; 

  const renderModalRemove = () => {
    return (
      <Transition appear show={isRemoveModal} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalRemove}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 " />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-8 h-[100px] w-[400px]">
                  <div className="bg-white border-t-4 border-[#19CFD8] rounded-b text-teal-900 px-4 py-3 shadow-md" role="alert">
                  <div className="flex">
                    <div className="py-1"><svg className="fill-[#19CFD8] h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
                    <div>
                      <p className="font-bold text-left">Removed</p>
                      <p className="text-sm">Property successfully removed.</p>
                    </div>
                  </div>
                </div>
                
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  }; 

  const renderSliderGallery = () => {
    return (
      <div className="flex-shrink-0  w-full h-[260px] ">
        <GallerySlider
          ratioClass=""
          galleryImgs={galleryImgs}
          className="w-full h-full overflow-hidden will-change-transform"
          uniqueID={`PropertyCardH_${id}`}
        />

        {saleOff && (
          <SaleOffBadge className="absolute right-0 top-0 !bg-orange-500" />
        )}
      </div>
    );
  };

  const renderTienIch = () => {
    return (
      <div className="inline-grid grid-cols-3 gap-2">
        <div className="flex items-center space-x-2">
          <span className="hidden sm:inline-block">
            <i className="las la-bed text-lg"></i>
          </span>
          <span className="text-xs text-neutral-500 dark:text-neutral-400">
           {data?.bedrooms} beds
          </span>
        </div>

        {/* ---- */}
        <div className="flex items-center space-x-2">
          <span className="hidden sm:inline-block">
            <i className="las la-bath text-lg"></i>
          </span>
          <span className="text-xs text-neutral-500 dark:text-neutral-400">
            {data?.bathrooms} baths
          </span>
        </div>

        {/* ---- */}
        <div className="flex items-center space-x-2">
          <span className="hidden sm:inline-block">
            <i className="las la-expand-arrows-alt text-lg"></i>
          </span>
          <span className="text-xs text-neutral-500 dark:text-neutral-400">
            {data?.sqrft} Sq. Fit
          </span>
        </div>
      </div>
    );
  };

 

  const renderContent = () => {
    return (
      <div className="flex-grow  flex flex-col items-start">
        <div className="space-y-4 w-full flex-grow">
          {/* <div className="inline-flex space-x-3">
            <Badge
              name={
                <div className="flex items-center">
                  <i className="text-sm las la-share-alt"></i>
                  <span className="ml-1">4 Network</span>
                </div>
              }
            />
            <Badge
              name={
                <div className="flex items-center">
                  <i className="text-sm las la-user-friends"></i>
                  <span className="ml-1">Family</span>
                </div>
              }
              color="yellow"
            />
          </div> */}

          <div className="flex w-full justify-between px-5 pt-6 items-end">
          <span className="flex items-center justify-center leading-none text-xl font-medium text-[#16385D]">
              {`${price}`}
            </span>
            {/* <StartRating reviewCount={author.reviewCount} point={author.reviewStart} /> */}
            {/* <FiveStartIconForRate iconClass="w-4 h-4" className="space-x-0.5" defaultPoint={author.reviewStart} /> */}
          </div>
          <div className="ml-[20px]">
          {renderTienIch()}
            <div className="flex flex-col  pt-[5px] h-[80px]">
              {/* {isAds && <Badge name="ADS" color="green" />} */}
              <h2 className="flex justify-left text-sm font-medium capitalize">
                <span className="line-clamp-2">{title}</span>
              </h2>
              <div className="flex justify-left text-sm font-light pt-[5px]">
                {address}
              </div>
            </div>
          </div>
          
    
          <div className="w-full h-[40px] flex justify-between">
            <div className="flex-auto bg-[#19CFD8] flex items-center justify-center">
                {like && isAuthenticated ? (
                  <button className="text-xs font-medium capitalize bg-[#00D3DB] text-white px-3 py-1 rounded-lg" onClick={() => {
                    if (id !== undefined && id !== null) {
                      removeProperty(id);
                    }
                  }}>
                    Remove
                  </button>
                ) : (
                  <button className="text-xs font-medium capitalize bg-[#00D3DB] text-white px-3 py-1 rounded-lg" onClick={() => {
                    if (id !== undefined && id !== null) {
                      saveProperty(id);
                    }
                  }}>
                    Save Now
                  </button>
                )}
              </div>  
            <div className="flex-auto bg-[#16385D] flex items-center justify-center">
                <button className="text-xs font-medium capitalize  text-white px-3 py-1 rounded-lg cursor-pointer" onClick={handleClick}>
                  View Details
                </button>
            </div>  
            {renderModalSave()}  
            {renderModalRemove()}  
          </div>  
          {/* <div className="w-14 border-b border-neutral-100 dark:border-neutral-800 "></div> */}
          {/* <div className="flex w-full justify-between items-end">
            <StartRating reviewCount={reviewCount} point={reviewStart} />
            <span className="flex items-center justify-center px-3 py-2 border border-secondary-500 rounded leading-none text-base font-medium text-secondary-500">
              {`${price},000`}
            </span>
          </div> */}
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-PropertyCardH group h-[520px]  relative bg-white border border-neutral-100  rounded-md overflow-hidden hover:shadow-xl transition-shadow ${className}`}
      data-nc-id="PropertyCardH"
    >
      {/* <Link to={href} className="absolute inset-0"></Link> */}
      <div className="h-full w-full flex flex-col  ">
        {renderSliderGallery()}
        {renderContent()}
      </div>
      <BtnLikeIcon
        colorClass={` bg-clear   text-white `}
        isLiked={like}
        className="absolute left-5 top-5 sm:left-3 sm:top-3 "
      />
    </div>
  );
};

export default PropertyCard;
